import { backendFetch } from '../apiUtils';

export const putNeeNor = async (neenor) => {
  const response = await backendFetch({
    url: 'v2/neenor/',
    method: 'PUT',
    options: {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(neenor),
    },
  });

  return response.data;
};

/**
 * V2 NeeNor address/details (Unified QA consignee/consignor).
 * Endpoint: v2/neenor/details
 * Returns an array (same shape as v1) so callers can use data[0].
 */
export const getNeeNorDetails = async (id) => {
  const response = await backendFetch({
    url: 'v2/neenor/details',
    method: 'GET',
    params: { id },
  });

  const payload = response?.data ?? response;
  if (payload == null) return [];
  return Array.isArray(payload) ? payload : [payload];
};

/**
 * V2 NeeNor / BP compliance status (Unified QA Compliance Checklist).
 * Endpoint: v2/neenor/status
 */
export const getNeeNorComplianceStatus = async (id, incoterm = '') => {
  const response = await backendFetch({
    url: 'v2/neenor/status',
    method: 'GET',
    params: { id, incoterm },
  });

  return response?.data ?? response;
};

export const getBulkNeeNorDetailsFromIds = async (ids = []) => {
  const response = await backendFetch({
    url: 'v2/neenor/detailsWithIds',
    method: 'GET',
    params: { ids: ids.join(',') },
  });
  return response?.data ?? response;
};
